import Vue from "vue";
import api from "@/api";

export default {
	actions: {
		async GetWebConfigList() {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetWebConfigList,
			});
			return response.data;
		},
		async UpdateWebConfig(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.UpdateWebConfig,
				data: entry,
			});
			return response.data;
		},
	},
};
